










import Vue from "vue";
import { Auth } from "@/@core";
import DocumentList from "@/@modules/dcm/components/DocumentList.vue";
import TarifCovidLayout from "@/@modules/tarif-covid/components/Layout.vue";
import {
  DcmDocumentListBaseQuery,
  DcmDocumentListConfig,
} from "@/@modules/dcm/interfaces/DcmDocumentListConfiguration";
export default Vue.extend({
  components: {
    DocumentList,
    TarifCovidLayout,
  },
  data() {
    const mutsKeys = {
      MUT1: 100,
      MUT2: 200,
      MUT3: 300,
      MUT4: 400,
      MUT5: 500,
      MUT6: 600,
      MUT9: 900,
      CIN: 700,
      INAMI: 800,
    } as { [key: string]: any };
    return {
      config: {
        title: "tarif-covid.input-files.title",
        itemKey: "O.cmis:objectId",
        itemName: "O.dcm:name",
        limit: {
          default: 10,
          options: [5, 10, 15],
        },
        query: {
          select: [
            { value: "O.cmis:objectId" },
            { value: "O.cmis:creationDate" },
            { value: "O.dcm:name" },
            { value: "O.dcm:createdBy" },
            { value: "O.dcm:type" },
            { value: "O.dcm:downloadable" },
          ],
          from: { value: "dcm:organization", as: "O" },
          //TODO: Retirer cette condition une fois que le backend prendra le relais.
          where: [
            {
              key: "O.dcm:type",
              value: [
                "shops",
                "careProviders",
                "forfaits",
                "encounters",
                "encounterOccured",
                "dmg",
                "medicalHouseSubscription",
              ],
              operator: "IN",
            },
            { key: "O.dcm:organizationName", value: Auth.claims?.groups[0], operator: "=" },
          ],
        },
        columns: [
          {
            label: "tarif-covid.date",
            key: "O.cmis:creationDate",
            align: "start",
            sortable: true,
            pipe: item => {
              return item["O.cmis:creationDate"] ? new Date(item["O.cmis:creationDate"]).toLocaleDateString() : "";
            },
          },
          { label: "tarif-covid.fileName", key: "O.dcm:name" },
          {
            label: "tarif-covid.type",
            key: "O.dcm:type",
            sortable: true,
            pipe: item => {
              return this.$tc(item["O.dcm:type"]);
            },
          },
          {
            label: "tarif-covid.createdBy",
            key: "O.dcm:createdBy",
          },
        ],
        filters: [
          {
            title: "tarif-covid.date",
            type: "dateRange",
            operator: "BETWEEN",
            key: "O.cmis:creationDate",
            label: "tarif-covid.date",
          },
          {
            title: "tarif-covid.type",
            type: "checkbox",
            operator: "IN",
            key: "O.dcm:type",
            label: "tarif-covid.type",
            options: [
              { label: this.$tc("encounterOccured"), value: "encounterOccured" },
              { label: this.$tc("encounters"), value: "encounters" },
              { label: this.$tc("careProviders"), value: "careProviders" },
              { label: this.$tc("shops"), value: "shops" },
              { label: this.$tc("forfaits"), value: "forfaits" },
              { label: this.$tc("dmg"), value: "dmg" },
              { label: this.$tc("medicalHouseSubscription"), value: "medicalHouseSubscription" },
            ],
          },
          {
            title: "tarif-covid.createdBy",
            type: "text",
            operator: "=",
            key: "O.dcm:createdBy",
            label: "tarif-covid.createdBy",
          },
        ],
        actions: {
          create: {
            label: "tarif-covid.upload",
            icon: "fa fa-plus",
            isDisabled: () => false,
            options: {
              title: "tarif-covid.upload",
              path: "/sites/cin-intertarif/documentlibrary/input_file",
              staticMetadatas: {
                "cmis:objectTypeId": "D:dcm:organization",
                "dcm:organizationId": mutsKeys[Auth.claims?.groups[0]],
                "dcm:organizationName": Auth.claims?.groups[0],
                "dcm:organizationType": "mutualities",
              },
              formMetadatas: [
                {
                  title: "tarif-covid.input-files.mutuals",
                  key: "dcm:type",
                  type: "select",
                  required: true,
                  items: [
                    "encounterOccured",
                    "encounters",
                    "careProviders",
                    "shops",
                    "forfaits",
                    "dmg",
                    "medicalHouseSubscription",
                  ],
                },
              ],
            },
          },
          download: {
            label: "tarif-covid.download",
            icon: "fa fa-download",
            isDisabled: () => false,
          },
          delete: {
            label: "tarif-covid.delete",
            icon: "fa fa-trash",
            isDisabled: () => false,
          },
        },
      } as DcmDocumentListConfig<DcmDocumentListBaseQuery>,
    };
  },
});
